import React, { useEffect, useMemo, useState } from "react";

/**
 * Scelta di un mezzo o di un'attrezzatura, con la categoria davanti.
 *
 * L'azienda ha piu' di duecento fra mezzi e attrezzature: un menu unico
 * costringe a scorrerli tutti per trovare un furgone. Qui si sceglie prima la
 * categoria e poi il mezzo, e il secondo menu resta corto.
 *
 * La categoria si posiziona da sola su quella del mezzo gia' scelto, cosi'
 * riaprendo una scheda compilata non si riparte da capo.
 */
export default function SceltaMezzo({ mezzi, valore, onCambia, disabilitato,
                                      testId }) {
  const [categoria, setCategoria] = useState("");

  const categorie = useMemo(() => {
    const viste = new Map();
    for (const m of mezzi || []) {
      const c = m.category || "Senza categoria";
      viste.set(c, (viste.get(c) || 0) + 1);
    }
    return [...viste.entries()].sort((a, b) => a[0].localeCompare(b[0]));
  }, [mezzi]);

  // Se c'e' gia' un mezzo scelto, la categoria si mette dov'e' lui.
  useEffect(() => {
    if (!valore) return;
    const suo = (mezzi || []).find((m) => m.id === valore);
    if (suo?.category) setCategoria(suo.category);
  }, [valore, mezzi]);

  const visibili = (mezzi || []).filter(
    (m) => !categoria || (m.category || "Senza categoria") === categoria);

  const classe = "w-full h-11 border border-slate-200 rounded-lg px-3 text-sm bg-white disabled:bg-slate-50 disabled:text-slate-500";

  return (
    <div className="grid gap-2 sm:grid-cols-2">
      <select value={categoria} disabled={disabilitato}
              data-testid={testId ? `${testId}-categoria` : undefined}
              onChange={(e) => {
                setCategoria(e.target.value);
                // Cambiando categoria, un mezzo di quella vecchia non c'entra piu'.
                const suo = (mezzi || []).find((m) => m.id === valore);
                if (suo && e.target.value
                    && (suo.category || "Senza categoria") !== e.target.value) {
                  onCambia("");
                }
              }}
              className={classe}>
        <option value="">Tutte le categorie</option>
        {categorie.map(([nome, quanti]) => (
          <option key={nome} value={nome}>{nome} ({quanti})</option>
        ))}
      </select>

      <select value={valore || ""} disabled={disabilitato}
              data-testid={testId}
              onChange={(e) => onCambia(e.target.value)}
              className={classe}>
        <option value="">
          {categoria ? `— scegli fra ${visibili.length} —` : "— scegli il mezzo —"}
        </option>
        {visibili.map((m) => (
          <option key={m.id} value={m.id}>
            {m.identifier}{m.brand ? ` · ${m.brand}` : ""}{m.model ? ` ${m.model}` : ""}
          </option>
        ))}
      </select>
    </div>
  );
}
